import { InputProps } from '@driftt/dds/dist/packages/core/src/lib/components/InputBase'
import { useCallback, useState } from 'react'
import isURL from 'validator/lib/isURL'

export const useUrlInput = ({
  onChange,
}: {
  onChange: (newVal: string) => void
}) => {
  const [hasUrlError, setHasUrlError] = useState(false)

  const handleUrlInputChange: InputProps['onChange'] = useCallback(
    (e) => {
      onChange(e.target.value)
      setHasUrlError(!isURL(e.target.value))
    },
    [onChange]
  )

  const handleUrlInputBlur: InputProps['onBlur'] = useCallback(
    (e) => {
      if (isURL(e.target.value)) {
        setHasUrlError(false)
        if (e.target.value.startsWith('http')) {
          onChange(e.target.value)
        } else {
          onChange(`https://${e.target.value}`)
        }
      } else {
        setHasUrlError(true)
      }
    },
    [onChange]
  )

  return {
    error: hasUrlError ? 'Please enter a valid URL' : '',
    handleUrlInputChange,
    handleUrlInputBlur,
  }
}
